document.addEventListener('DOMContentLoaded', function () {
  const currentDomain = window.location.hostname;

  const domainMap = {
    'pkfdigital.test': 'pkfdigital.nz.test',
    'pkfdigital.com.au': 'pkfdigital.co.nz',
  };

  const oldDomain = Object.keys(domainMap).find(
    (key) => domainMap[key] === currentDomain
  );
  const newDomain = domainMap[oldDomain] || null;

  if (oldDomain && newDomain) {
    document
      .querySelectorAll('a[href*="' + oldDomain + '"]')
      .forEach((link) => {
        console.log(link.href);

        link.href = link.href.replace(oldDomain, newDomain);
        Object.keys(domainMap).forEach((oldDomain) => {
          if (link.href.includes(oldDomain)) {
            link.href = link.href.replace(oldDomain, newDomain);
          }
        });
      });

    document.querySelectorAll('form[action]').forEach(function (form) {
      Object.keys(domainMap).forEach((oldDomain) => {
        if (form.action.includes(oldDomain)) {
          form.action = form.action.replace(oldDomain, newDomain);
        }
      });
    });
  }

  // // Define your domain mappings (key = old domain, value = new domain)
  // const domainMap = {
  //   'pkfdigital.nz.test': 'pkfdigital.nz.test',
  //   'pkfdigital.test': 'pkfdigital.co.nz',
  // };

  // // Find the correct replacement domain based on the current host
  // const newDomain = domainMap[currentDomain] || null;

  // if (newDomain) {
  //   // Replace links
  //   document.querySelectorAll('a[href]').forEach(function (link) {
  //     Object.keys(domainMap).forEach((oldDomain) => {
  //       if (link.href.includes(oldDomain)) {
  //         link.href = link.href.replace(oldDomain, newDomain);
  //       }
  //     });
  //   });

  //   // Replace form actions
  //   document.querySelectorAll('form[action]').forEach(function (form) {
  //     Object.keys(domainMap).forEach((oldDomain) => {
  //       if (form.action.includes(oldDomain)) {
  //         form.action = form.action.replace(oldDomain, newDomain);
  //       }
  //     });
  //   });
  // }
});
